<template>
  <donut-chart
    class="chart"
    with-percentage
    :styles="myStyles"
    :options="options"
    :chart-data="chartData"
    :show-label="false"
    :before-draw-callback="beforeDrawCallback"
  />
</template>

<script>
import DonutChart from "@core/components/charts/DonutChart.vue";

export default {
  name: "AccountUsageDonutChart",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    innerLabel: { type: String, default: "Usage" },
    data: { type: Array, default: () => [], required: true },
    backgroundColors: { type: Array, default: () => ["#03B6FC", "#CDF0FE"] }
  },
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    DonutChart
  },
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      options: {
        cutoutPercentage: 70,
        responsive: true,
        legend: { display: false },
        tooltips: { enabled: false },
        datalabels: { display: false },
        labels: { display: false },
        cutout: "50%",
        rotation: Math.PI,
        circumference: Math.PI
      },
      myStyles: {
        height: `100px`,
        width: `210px`
      }
    };
  },
  computed: {
    chartData() {
      return {
        labels: ["", ""],
        datasets: [
          {
            backgroundColor: this.backgroundColors,
            // @todo add the usage details left for the chart
            data: this.data
          }
        ]
      };
    }
  },
  methods: {
    beforeDrawCallback(chart) {
      const ctx = chart.chart.ctx;
      ctx.fillText(this.innerLabel, 75, 150);
      ctx.save();
    }
  }
};
</script>